import React from "react";

/**
 * Simple React Error Boundary yang membungkus route dgn fallback UI Indonesian.
 * Dipakai utk Quick Order route supaya crash di child tidak nge-white-screen.
 * v2 — Tampilkan detail error di fallback (dev: full stack, prod: name+message).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Catat error ke console (tidak boleh crash bila logger tidak tersedia)
    try {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary] Caught:", error, info && info.componentStack);
    } catch (_ignored) {}
    this.setState({ info });
  }

  handleReload = () => {
    try { window.location.reload(); } catch (_ignored) {}
  };

  render() {
    if (this.state.hasError) {
      const err = this.state.error || {};
      const info = this.state.info || {};
      const isDev = process.env.NODE_ENV !== "production";
      const errName = err.name || "Error";
      const errMsg = err.message || String(err) || "Unknown error";
      const errStack = err.stack || "";
      const compStack = info.componentStack || "";
      return (
        <div
          data-testid="qo-error-boundary"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "#fafafa",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          <div style={{ maxWidth: 520, width: "100%", textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#18181b", marginBottom: 8 }}>
              Terjadi kesalahan
            </div>
            <div style={{ fontSize: 14, color: "#52525b", marginBottom: 16 }}>
              Silakan muat ulang atau hubungi admin.
            </div>
            <button
              onClick={this.handleReload}
              style={{
                height: 44,
                padding: "0 20px",
                borderRadius: 8,
                background: "#ea580c",
                color: "#fff",
                border: "none",
                fontWeight: 700,
                cursor: "pointer",
              }}
              data-testid="qo-error-reload-btn"
            >
              Muat Ulang
            </button>

            {/* v84.120 — Detail error utk debug (sementara). Dev: full stack;
                prod: hanya name + message di teks kecil abu-abu. */}
            {isDev ? (
              <pre
                data-testid="qo-error-detail-dev"
                style={{
                  marginTop: 20,
                  padding: 12,
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 8,
                  fontSize: 11,
                  lineHeight: 1.4,
                  color: "#991b1b",
                  textAlign: "left",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  maxHeight: 400,
                  overflow: "auto",
                }}
              >
                <b>{errName}:</b> {errMsg}
                {errStack ? "\n\n" + errStack : ""}
                {compStack ? "\n\n--- Component Stack ---" + compStack : ""}
              </pre>
            ) : (
              <div
                data-testid="qo-error-detail-prod"
                style={{
                  marginTop: 16,
                  fontSize: 11,
                  color: "#a1a1aa",
                  wordBreak: "break-word",
                  lineHeight: 1.4,
                }}
              >
                {errName}: {errMsg}
              </div>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
